import DataStoreNodesStore from "csi/components/select/store/DataStoreNodesStore";
import { createConfigurableAttributeSelectOption } from "./attributeDefinitionService";

class ConfigurableAttributeSelectStore extends DataStoreNodesStore {
	resultTransform = createConfigurableAttributeSelectOption;
}

export default ConfigurableAttributeSelectStore;